import React from "react";
import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";

import numberFormatter from "utils/numberFormatter";
import KPIComparator from "components/visuals/KPIComparator";

import { useAppSelector } from "store";
import { selectComparator, selectStore } from "modules/customer/insights/portfolio/portfolioSlice";
import { selectors } from "modules/customer/insights/portfolio/competition/marketShare";

const LocalMarketShare = () => {
    const selectedStore = useAppSelector(selectStore);
    const selectedComparator = useAppSelector(selectComparator);
    const localMarketShare = useSelector(state => selectors.localMarketShare(state));
    const { loading, error, value, percentageDifference } = localMarketShare;
    const valueFormatted = numberFormatter.toPercentage(value, true);
    const label = `${selectedStore.name} Local Market Share vs ${selectedComparator.name}`;

    return (
        <Box width="100%" height="100%" data-cy="local-market-share">
            <KPIComparator loading={loading} error={error} label={label} value={valueFormatted} percentage={percentageDifference} />
        </Box>
    );
};

export default LocalMarketShare;
